<!-- eslint-disable max-len -->
<template>
  <div class="flex flex-col">
    <div class="flex flex-col items-end">
      <div class="w-10/12 md:w-11/12 flex flex-col justify-center items-center">
        <custom-modal ref="addCompany">
          <template v-slot:header>
            <h1>{{ $t('add-company.title') }}</h1>
          </template>
          <template v-slot:body>
            <add-company @company-has-been-added="onCompanyHasBeenAdded"></add-company>
          </template>
        </custom-modal>
        <div class="flex flex-row w-2/3 mx-auto mt-16 relative items-center justify-between md:justify-center">
          <h1 class="text-3xl font-bold text-aitmes-blue dark:text-white w-2/3 md:w-full text-left md:text-center">{{ $t('companies-list') }}</h1>
          <div class="w-full flex justify-end absolute">
            <button
              class="rounded-md text-white dark:text-slate-700 bg-aitmes-blue dark:bg-white/70 px-2 bg-opacity-75
              hover:bg-opacity-100 text-2xl font-bold"
              @click="$refs.addCompany.openModal"
            >
            &plus;
            </button>
          </div>
        </div>
        <companies-list></companies-list>
      </div>
    </div>
  </div>
</template>

<script>
import CustomModal from '@/components/base/CustomModal.vue';
import AddCompany from '@/components/companies/AddCompany.vue';
import CompaniesList from '@/components/companies/CompaniesList.vue';
import { useToast } from 'vue-toastification';

export default {
  setup() {
    const toast = useToast();

    return { toast };
  },
  components: {
    CustomModal,
    AddCompany,
    CompaniesList,
  },
  methods: {
    onCompanyHasBeenAdded() {
      this.$refs.addCompany.closeModal();
      this.toast.success(this.$t('add-company-alert'));
    },
  },
};
</script>
